import axios from 'axios';

export default class ServicioListadoInformacionService {

    getServicioListadoInformacion(info) {            
        const url = process.env.VUE_APP_APIURL + `/api/serviciolistadoinformacion`;    
        return axios.post(url,info,{headers:{"Content-Type" : "application/json"}}).then(res=>res.data);
    }

  
    createServicioListadoInformacion(info){
        const url = process.env.VUE_APP_APIURL + `/api/serviciolistadoinformacionalta`;     
        return axios.post(url,info,{headers:{"Content-Type" : "application/json"}}).then(res=>res.data);
    }

    deleteServicioListadoInformacion(info){
        const url = process.env.VUE_APP_APIURL + `/api/serviciolistadoinformacionbaja`;     
        return axios.post(url,info,{headers:{"Content-Type" : "application/json"}}).then(res=>res.data);
    }

    updateServicioListadoInformacion(info){
        const url = process.env.VUE_APP_APIURL + `/api/serviciolistadoinformacionedicion`;     
        return axios.put(url,info,{headers:{"Content-Type" : "application/json"}}).then(res=>res.data);
    }

}